import React from 'react';
import img1 from '../assets/image 10.png';
import img2 from '../assets/image 11.png';
import img3 from '../assets/image 12.png';
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { useState } from 'react';
import HdfcHistory from './HdfcHistory';

const CreditCards = () => {
    const [isOpen,setIsOpen] = useState(-1);

    function handleOpen(val){
        setIsOpen(val);
    }

    return (
    <div className='flex flex-col items-center w-[94%] lg:w-[90%] my-3'>
        <div className='visible flex justify-around items-center w-full h-14 rounded-t-lg bg-blue-500 bg-opacity-50 mt-2 text-center'> 
            <p className='text-primary text-lg w-[20%]'>Bank Name</p>
            <p className='text-primary text-lg w-[20%]'>Open Date</p>
            <p className='text-primary text-lg w-[20%]'>Age</p>
        </div>
        <div className='visible flex justify-around items-center w-full h-14 text-center bg-blue-100'> 
            <p className='flex w-[20%] justify-center'><img src={img1} width={40} alt=''></img></p>
            <p className='w-[20%] max-xl:text-sm'>28/01/2022</p>
            <div className='flex justify-end items-center w-[20%] '>
                <p className='mr-1 lg:mr-4 xl:mr-8 max-xl:text-sm'>2 Years</p>
                {isOpen===0 ? <IoIosArrowDropupCircle onClick={()=> handleOpen(-1)} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/> : <IoIosArrowDropdownCircle onClick={()=> handleOpen(0)} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/>}
            </div>
        </div>
        <div className={`grid w-full transition-smooth will-change-auto duration-300 overflow-hidden ${isOpen===0 ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
            {<HdfcHistory/>}
        </div>
        <div className='visible flex justify-around items-center w-full h-14 text-center bg-slate-100'> 
            <p className='flex w-[20%] justify-center'><img src={img2} width={40} alt=''></img></p>
            <p className='w-[20%] max-xl:text-sm'>28/01/2022</p>
            <div className='flex justify-end items-center w-[20%] '>
                <p className='mr-1 lg:mr-4 xl:mr-8 max-xl:text-sm'>2 Years</p>
                {isOpen===1 ? <IoIosArrowDropupCircle onClick={()=> handleOpen(-1)} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/> : <IoIosArrowDropdownCircle onClick={()=> handleOpen(1)} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/>}
            </div>
        </div>
        <div className={`grid w-full transition-smooth will-change-auto duration-300 overflow-hidden ${isOpen===1 ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
            {<HdfcHistory/>}
        </div>
        <div className='visible flex justify-around items-center w-full h-14 text-center bg-blue-100 rounded-b-lg'> 
            <p className='flex w-[20%] justify-center'><img src={img3} width={40} alt=''></img></p>
            <p className='w-[20%] max-xl:text-sm'>28/01/2022</p>
            <div className='flex justify-end items-center w-[20%] '>
                <p className='mr-1 lg:mr-4 xl:mr-8 max-xl:text-sm'>2 Years</p>
                {isOpen===2 ? <IoIosArrowDropupCircle onClick={()=> handleOpen(-1)} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/> : <IoIosArrowDropdownCircle onClick={()=> handleOpen(2)} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/>}
            </div>
        </div>
        <div className={`grid w-full transition-smooth will-change-auto duration-300 overflow-hidden ${isOpen===2 ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
            {<HdfcHistory/>}
        </div>
    </div>
    )
}

export default CreditCards;